document.addEventListener('input', updateAllTcustomizerSummaries);
document.addEventListener('change', updateAllTcustomizerSummaries);
document.addEventListener('DOMContentLoaded', updateAllTcustomizerSummaries);

function getInputNumber(fieldId) {
  if (!fieldId) return 0;

  const field = document.getElementById(fieldId);
  if (!field) return 0;

  const input = field.querySelector('.tcustomizer__text-field');
  if (!input) return 0;

  const rawValue = input.value.replace(/\D/g, '');
  return rawValue ? Number(rawValue) : 0;
}

function getRadioText(fieldId) {
  let checkedRadio = null;

  if (fieldId) {
    const field = document.getElementById(fieldId);
    if (field) {
      checkedRadio = field.querySelector('input[type="radio"]:checked');
    }
  }

  if (!checkedRadio) {
    checkedRadio = document.querySelector(
      'variant-selects input[type="radio"][name^="Thickness"]:checked'
    );
  }

  if (!checkedRadio) {
    checkedRadio = document.querySelector(
      'input[type="radio"][value$="mm"]:checked'
    );
  }

  return checkedRadio ? checkedRadio.value.trim() : '';
}

function formatValue(value) {
  return `${Number(value).toLocaleString(undefined, {
    maximumFractionDigits: 2
  })} (mm)`;
}

function updateSummaryBox(box) {
  const formula = box.dataset.formula || 'hedge-length-only';

  const panelThicknessFieldId = box.dataset.sourceThickness;
  const lengthFieldId = box.dataset.sourceLength;
  const returnLengthFieldId = box.dataset.sourceReturnLength;
  const aboveHeightFieldId = box.dataset.sourceAboveHeight;
  const belowHeightFieldId = box.dataset.sourceBelowHeight;
  const desktopThicknessFieldId = box.dataset.sourceDesktopThickness;

  const thicknessHeading = box.querySelector('.js-summary-thickness');
  const lengthHeading = box.querySelector('.js-summary-length');
  const returnLengthHeading = box.querySelector('.js-summary-return-length');
  const overallHeightHeading = box.querySelector('.js-summary-overall-height');
  const totalHeading = box.querySelector('.js-summary-total');

  const panelThicknessText = getRadioText(panelThicknessFieldId);

  const length = getInputNumber(lengthFieldId);
  const returnLengthInput = getInputNumber(returnLengthFieldId);
  const aboveHeight = getInputNumber(aboveHeightFieldId);
  const belowHeight = getInputNumber(belowHeightFieldId);
  const desktopThickness = getInputNumber(desktopThicknessFieldId);

  if (thicknessHeading) {
  thicknessHeading.textContent = panelThicknessText
    ? `${panelThicknessText.replace('mm', '')} (mm)`
    : 'Select thickness';
}

  if (formula === 'haven') {
    const screenLengthDisplay = length;
    const returnLength = returnLengthInput / 2;
    const totalScreenLength = length + returnLengthInput;
    const overallHeight = aboveHeight + belowHeight + desktopThickness;

    if (lengthHeading) {
      lengthHeading.textContent = screenLengthDisplay
        ? formatValue(screenLengthDisplay)
        : 'Screen length will appear here';
    }

    if (returnLengthHeading) {
      returnLengthHeading.textContent = returnLength
        ? formatValue(returnLength)
        : 'Return length will appear here';
    }

    if (overallHeightHeading) {
      overallHeightHeading.textContent = overallHeight
        ? formatValue(overallHeight)
        : 'Overall height will appear here';
    }

    if (totalHeading) {
      totalHeading.textContent =
        totalScreenLength && overallHeight
          ? `${formatValue(totalScreenLength)} L | ${formatValue(overallHeight)} H`
          : 'Total size will appear here';
    }

    return;
  }

  if (formula === 'nook') {
    const screenLengthDisplay = length;
    const returnLength = returnLengthInput / 2;
    const totalScreenLength = length + returnLength;
    const overallHeight = aboveHeight + belowHeight + desktopThickness;

    if (lengthHeading) {
      lengthHeading.textContent = screenLengthDisplay
        ? formatValue(screenLengthDisplay)
        : 'Screen length will appear here';
    }

    if (returnLengthHeading) {
      returnLengthHeading.textContent = returnLength
        ? formatValue(returnLength)
        : 'Return length will appear here';
    }

    if (overallHeightHeading) {
      overallHeightHeading.textContent = overallHeight
        ? formatValue(overallHeight)
        : 'Overall height will appear here';
    }

    if (totalHeading) {
      totalHeading.textContent =
        totalScreenLength && overallHeight
          ? `${formatValue(totalScreenLength)} L | ${formatValue(overallHeight)} H`
          : 'Total size will appear here';
    }

    return;
  }

  if (formula === 'hedge-privacy') {
    const overallHeight = aboveHeight + belowHeight + desktopThickness;

    if (lengthHeading) {
      lengthHeading.textContent = length
        ? formatValue(length)
        : 'Enter desk length in mm';
    }

    if (overallHeightHeading) {
      overallHeightHeading.textContent = overallHeight
        ? formatValue(overallHeight)
        : 'Overall height will appear here';
    }

    if (totalHeading) {
      totalHeading.textContent =
        length && overallHeight
          ? `${formatValue(length)} W / ${formatValue(overallHeight)} H`
          : 'Total size will appear here';
    }

    return;
  }

  if (formula === 'hedge-length-only') {
    if (lengthHeading) {
      lengthHeading.textContent = length
        ? formatValue(length)
        : 'Enter desk length in mm';
    }

    if (totalHeading) {
      totalHeading.textContent = length
        ? formatValue(length)
        : 'Total will appear here';
    }

    return;
  }
}

function updateAllTcustomizerSummaries() {
  document.querySelectorAll('.tcustomizer-summary-box').forEach(updateSummaryBox);
}

setInterval(updateAllTcustomizerSummaries, 300);